/**
 * @module app.ext.iccc
 */

import { autoinject, transient } from 'aurelia-framework';
import { IcccManager } from 'app/ext/iccc/iccc-manager';
import { CasePageContext } from 'app/cm/lib/case-page-context';
import * as CM from 'app/cm/models/essette-api';


@transient()
@autoinject()
export class ExtIcccCustomElement {

    ////****************** Fields and Properties ************************************////

    protected case: CM.Case | null = null;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        protected iccc: IcccManager,
        private context: CasePageContext) {
    }

    protected bind(): void {
        if(!this.case) { this.case = this.context.case; }
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////
    protected open(): void {
        if(this.case) {
            this.iccc.open(this.case);
        }
    }


    ////****************** Service Calls ********************************************////

}
